import React, { useEffect, useState } from 'react';
import { martyrsApi } from '../services/api';

const MartyrSelect = ({ value, onChange, token, required = true, emptyLabel, className = 'form-select' }) => {
  const [martyrs, setMartyrs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await martyrsApi.getOptions(token);
        setMartyrs(data.martyrs || []);
      } catch (error) {
        setMartyrs([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [token]);

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      required={required}
      disabled={loading}
    >
      <option value="">
        {loading ? 'جاري تحميل أسماء الشهداء...' : (emptyLabel || (required ? 'اختر اسم الشهيد' : 'عامة — بدون شهيد محدد'))}
      </option>
      {martyrs.map((martyr) => (
        <option key={martyr.id} value={martyr.id}>
          {martyr.name_ar} {martyr.name_en ? `- ${martyr.name_en}` : ''}
        </option>
      ))}
    </select>
  );
};

export default MartyrSelect;
